/** Split a calendar month into Mon–Sun ranges clipped to the month. */
import { daysInMonth, weekdayMon0, ddKey } from "./dates";

/**
 * @param {number} year
 * @param {number} month0 0-based month
 * @returns {{ start: number, end: number, dayKeys: string[] }[]}
 */
export function monthWeekRanges(year, month0) {
  const dim = daysInMonth(year, month0);
  const weeks = [];
  let d = 1;
  while (d <= dim) {
    const wd = weekdayMon0(year, month0, d); // Mon=0 … Sun=6
    const start = d;
    const end = Math.min(d + (6 - wd), dim);
    const dayKeys = [];
    for (let x = start; x <= end; x++) dayKeys.push(ddKey(x));
    weeks.push({ start, end, dayKeys });
    d = end + 1;
  }
  return weeks;
}

/** Subset of calendar.days for a week range. */
export function calendarDaysSubset(calendarDays, dayKeys) {
  const out = {};
  for (const k of dayKeys) {
    if (calendarDays?.[k] != null) out[k] = calendarDays[k];
  }
  return out;
}
